"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridSingleSelectionPlugin = void 0;
const selectionGridRow_1 = require("../../renderers/selectionGridRow");
function gridSingleSelectionPlugin(config) {
    return () => ({
        rowRenderer: (0, selectionGridRow_1.createGridSelectionRowRenderer)({
            onSelect: config.onSelect,
            isSelected: config.isSelected,
            onContextMenu: config.onContextMenu,
            onRowClick: config.onRowClick,
            onRowDoubleClick: config.onRowDoubleClick
        })
    });
}
exports.gridSingleSelectionPlugin = gridSingleSelectionPlugin;
//# sourceMappingURL=gridSingleSelectionPlugin.js.map